import Info from 'components/Info'
import { Error, InfoRedStyle, Row, ValidButton } from '../ProductListTable.definitionFields'
import { ProductCreation } from '@Arti-zen/package-backoffice'

type TProps = {
  givenNetPrice: string | number
  expectedNetPrice: number
  errorMessage: string
  correctProduct: (corrections: Partial<ProductCreation>) => void
}

export default function NetPriceProductErrorTable({
  givenNetPrice,
  expectedNetPrice,
  errorMessage,
  correctProduct,
}: TProps) {
  const chooseExpectedCoef = (e: React.MouseEvent) => {
    e.preventDefault()
    e.stopPropagation()
    correctProduct({ netPrice: expectedNetPrice })
  }

  return (
    <Row>
      <Error>{givenNetPrice ? `${givenNetPrice}€` : '0 €'}</Error>
      <ValidButton onClick={chooseExpectedCoef}>{expectedNetPrice} €</ValidButton>
      <Info text={errorMessage} style={InfoRedStyle} />
    </Row>
  )
}
